<template lang="pug">
  div(class="order-list-page px-3 px-md-4 px-xl-5 pb-5")
    div(class="order-list-heading d-flex justify-content-between position-relative")
      div(class="d-flex")
        h4(class="font-weight-bold text-left") 購物紀錄
    div(class="order-history-notice my-3") 僅可查詢當年度及前一年度之訂購記錄
    div(class="order-list-tools my-3" v-if="trackingVisible")
      div(class="order-source-tabs" role="tablist" aria-label="訂單來源" v-if="trackingVisible")
        button(type="button" :class="{ active: sourceTab === 'online' }" @click="changeSource('online')") 線上訂單
        button(type="button" :class="{ active: sourceTab === 'store' }" @click="changeSource('store')") 實體訂單
        button(type="button" :class="{ active: sourceTab === 'unknown' }" @click="changeSource('unknown')") 來源待確認
    div(class="py-2")
      div(class="d-grid grid-table border" v-if="filteredOrders.length" :style="{ '--order-grid-columns': trackingVisible ? '2fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr' : '2fr 2fr 1fr 1fr 1fr 1fr 1fr', gridTemplateColumns: 'var(--order-grid-columns)' }")
        div(class="text-center title") 訂單編號
        div(class="text-center title") 下單時間
        div(class="text-center title") 訂單金額
        div(class="text-center title") 訂單積分
        div(class="text-center title") 訂單狀態
        div(class="text-center title" v-if="trackingVisible") 配送進度
        div(class="text-center title") 發票號碼
        div(class="text-center title") 取消訂單
        div(class="grid-span line d-none d-lg-block")
        div(class="d-grid grid-tr grid-span fs-lg-16 fs-14 position-relative" v-for="model in filteredOrders" :key="model.id")
          div(class="px-3 py-2 d-lg-none font-weight-bold") 訂單編號
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            router-link(class="py-lg-3 py-2 font-weight-bold text-success stretched-link" :to="'/member/order/' + model.id ") {{ model.order_number }}
          div(class="px-3 py-2 d-lg-none font-weight-bold") 下單時間
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            div(class="py-lg-3 py-2") {{ dayFormat(model.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          div(class="px-3 py-2 d-lg-none font-weight-bold") 訂單金額
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            div(class="py-lg-3 py-2") NT {{ commaFormat(model.total_price) }}
          div(class="px-3 py-2 d-lg-none font-weight-bold") 訂單積分
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            div(class="py-lg-3 py-2") {{ commaFormat(model.total_pv) }}
          div(class="px-3 py-2 d-lg-none font-weight-bold") 訂單狀態
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            div(class="py-lg-3 py-2") {{ model.display_status_name }}
          div(class="px-3 py-2 d-lg-none font-weight-bold" v-if="trackingVisible") 配送進度
          div(class="d-flex justify-content-lg-center align-items-lg-center" v-if="trackingVisible")
            div(class="py-lg-3 py-2 tracking-status") {{ trackingStatus(model) }}
          div(class="px-3 py-2 d-lg-none font-weight-bold") 發票號碼
          div(class="d-flex justify-content-lg-center align-items-lg-center")
            div(class="py-lg-3 py-2") {{ model.invoice_number }}
          template(v-if="model.can_cancel")
            div(class="grid-span d-lg-none")
              div(class="p-3 btn-position")
                button(
                  class="btn btn-outline-success w-100 cancel-order-button"
                  type="button"
                  :class="{ 'is-loading': cancelLoadingId === model.id }"
                  :disabled="cancelLoadingId !== null"
                  @click="cancelOrder(model.id)"
                )
                  span(v-if="cancelLoadingId !== model.id") 取消訂單
                  span(v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true")
            div(class="d-lg-flex d-none justify-content-lg-center align-items-lg-center")
              div(class="py-3 btn-position")
                button(
                  class="btn btn-icon text-dark cancel-order-icon-button"
                  type="button"
                  :class="{ 'is-loading': cancelLoadingId === model.id }"
                  :disabled="cancelLoadingId !== null"
                  @click="cancelOrder(model.id)"
                )
                  span(v-if="cancelLoadingId === model.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true")
                  Icon(v-else class="btn-icon rotate-45" pattern="Add" size="24")
          div(class="grid-span line")
      div(class="text-center text-muted py-5" v-else)
        span(v-if="sourceTab === 'store'") 目前尚無實體店面訂單貨態
        span(v-else) 查無購物紀錄
    div(class="d-flex justify-content-center py-3" v-if="this.ListModel.last_page > 1")
      PaginationList(v-bind="paginationSettings")
  //-     PaginationList(
  //- :page-count="20"
  //- :click-handler="functionName"
  //- :prev-text="'Prev'"
  //- :next-text="'Next'"
  //- :container-class="'pagination'")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { updateOrders, getOrdersSearch } from '../../../../api'
import { OrderModel } from '../../../../models'
import { ListModel } from '../../../../library/proto'
import * as Icon from '../../../../components/icon'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-cn'
import { Toast } from '@/utils/helper'

export default {
  name: 'OrderList',
  components: {
    DatePicker
  },
  data() {
    const minDateDefault = dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD')
    const maxDateDefault = dayjs().endOf('year').format('YYYY-MM-DD')
    return {
      ListModel: new ListModel({
        model: OrderModel
      }),
      search: {
        page: 1,
        _type: '',
        _from: '',
        _to: ''
      },
      // currentPageNum: this.search.page,
      minDateDefault,
      maxDateDefault,
      minDate: minDateDefault,
      maxDate: maxDateDefault,
      cancelLoadingId: null,
      sourceTab: 'online',
      trackingVisible: false,
      trackingRefreshTimer: null,
      trackingRefreshBusy: false,
      trackingVisibilityHandler: null
    }
  },
  created() {
    if (!this.UserData.loginStatus) {
      this.$store.commit('setLoginPage', this.$route.path)
      this.$router.replace('/member/login')
      return
    }
    // console.log('created 1', this.search)
    this.getOrders()
    this.startTrackingStatusRefresh()
    // this.changePage(this.ListModel.current_page)
    // console.log('created ListModel:', this.ListModel)
    // console.log('created', this.search)
    // console.log(this.currentPageNum)
  },
  computed: {
    ...mapState({
      Orders: state => state.model.Orders,
      UserData: state => state.model.UserData
    }),
    filteredOrders() {
      return this.ListModel.data
    },
    paginationSettings() {
      // console.log('paginationSettings')
      // console.log(this.changePage)
      const arrow = JSON.parse(JSON.stringify(Icon.ArrowRight))
      const arrowAttrs = Object.keys(arrow.attrs)
        .map(key => ` ${key}="${arrow.attrs[key]}"`)
        .join('')
      // console.log('paginationSettings:', this.$route.query.page)
      // console.log('ListModel_current_page', this.ListModel.current_page)
      // console.log('this.Search:', this.search.page)
      return {
        // forcePage: Number(this.$route.query.page) || 1,
        // forcePage: Number(this.ListModel.current_page),
        // forcePage: Number(this.changePage),
        value: Number(this.search.page),
        // forcePage: Number(this.search.page),
        pageCount: this.ListModel.last_page,
        prevText: `<div><svg${arrowAttrs}><g transform="rotate(180 12 12)">${arrow.path}</g></svg></div>`,
        nextText: `<div><svg${arrowAttrs}>${arrow.path}</svg></div>`,
        containerClass: 'pagination',
        pageClass: 'pagination-item',
        prevClass: 'pagination-prev',
        nextClass: 'pagination-next',
        clickHandler: this.changePage
      }
    }
  },
  watch: {
    $route(to) {
      console.log('watch', to)
      this.getOrders()
    }
  },
  beforeDestroy() {
    if (this.trackingRefreshTimer) clearInterval(this.trackingRefreshTimer)
    if (this.trackingVisibilityHandler) {
      document.removeEventListener('visibilitychange', this.trackingVisibilityHandler)
      window.removeEventListener('focus', this.trackingVisibilityHandler)
    }
  },
  methods: {
    startTrackingStatusRefresh() {
      this.trackingVisibilityHandler = () => {
        if (document.visibilityState === 'visible') this.refreshTrackingStatus()
      }
      document.addEventListener('visibilitychange', this.trackingVisibilityHandler)
      window.addEventListener('focus', this.trackingVisibilityHandler)
      this.trackingRefreshTimer = setInterval(() => {
        if (document.visibilityState === 'visible') this.refreshTrackingStatus()
      }, 10000)
    },
    async refreshTrackingStatus() {
      if (this.trackingRefreshBusy || !this.UserData.loginStatus) return
      this.trackingRefreshBusy = true
      try {
        await this.getOrders()
      } finally {
        this.trackingRefreshBusy = false
      }
    },
    changeSource(source) {
      if (this.sourceTab === source) return
      this.sourceTab = source
      this.search.page = 1
      this.getOrders()
    },
    trackingStatus(order) {
      const shipments = order.shipments || []
      if (!shipments.length) return '尚無貨態'
      const sourceShipments = shipments.filter(item => item.source_type === this.sourceTab)
      const visibleShipments = sourceShipments.length ? sourceShipments : shipments
      const active = visibleShipments.find(item => item.sync_status !== 'completed') || visibleShipments[0]
      return active.latest_status_text || '物流資料準備中'
    },
    functionName(page) {
      console.log(page)
      return page
    },
    ...mapActions(['getListModel', 'getModelById']),
    startDate(date) {
      return dayjs(date).isBefore(this.minDate, 'day') || dayjs(date).isAfter(this.maxDate, 'day')
    },
    endDate(date) {
      return this.startDate(date)
    },
    orderSearchDate(value, fallback) {
      const date = dayjs(value)
      if (!value || !date.isValid()) return fallback
      if (date.isBefore(this.minDate, 'day')) return this.minDate
      if (date.isAfter(this.maxDate, 'day')) return this.maxDate
      return date.format('YYYY-MM-DD')
    },
    async getOrders() {
      this.search = {
        page: Number(this.$route.query.page) || 1,
        _type: 'orderDate',
        _from: '',
        _to: ''
      }
      const res = await getOrdersSearch({
        ...this.search,
        _from: (this.search._from || this.minDateDefault) + ' 00:00:00',
        _to: (this.search._to || this.maxDateDefault) + ' 23:59:59',
        order_source: this.sourceTab
      })
      this.ListModel.set(res.data)
      this.trackingVisible = Boolean(res.data.shipping_tracking_visible)
      return this.ListModel
    },
    beforeUpdate() {
      this.getOrders()
    },
    cancelOrder(id) {
      if (this.cancelLoadingId) {
        return
      }
      Toast.fire({
        title: '確定取消訂單?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        reverseButtons: false
      }).then(result => {
        if (result.isConfirmed) {
          this.cancelLoadingId = id
          updateOrders(id, {
            order_status: 9
          }).then(() => {
            const order = this.ListModel.data.find(p => Number(p.id) === id)
            if (order) {
              order.order_status = 9
              order.display_status_name = '取消訂單'
              order.can_cancel = false
            }
          }).finally(() => {
            this.cancelLoadingId = null
          })
        }
      })
    },
    changePage(page) {
      // console.log('changePage', page)
      this.search.page = page
      this.routerLink()
    },
    searchQuery(query = {}) {
      // console.log('searchQuery-query', query)
      const search = {}
      if (query.page) {
        search.page = query.page
      }
      if (query._from) {
        search._from = query._from
      }
      if (query._to) {
        search._to = query._to
      }
      if (query._type) {
        search._type = query._type
      }
      if (query._to || query._from) {
        search._type = 'orderDate'
      }
      return search
    },
    clickSearch() {
      // console.log('clickSearch', this.$route.query)
      this.search = Object.assign({
        page: 1,
        _type: 'orderDate',
        _from: this.search._from,
        _to: this.search._to
      })

      this.routerLink()
    },
    routerLink() {
      // console.log('routerLink', this.search)
      this.$router.push({
        query: this.searchQuery(this.search)
      })
    }
  }
}
</script>

<style lang="scss">
.grid-table {
  .title {
    padding: 12px 0;
    @media (max-width: 991.5px) {
      display: none;
    }
  }
}
.grid-tr {
  grid-template-columns: var(--order-grid-columns, 2fr 2fr 1fr 1fr 1fr 1fr 1fr 1fr);
  @media (max-width: 991.5px) {
    grid-template-columns: auto 1fr;
  }
}
.order-source-tabs {
  display: inline-flex;
  flex: 0 0 auto;
  border: 1px solid #16845f;
  border-radius: 6px;
  overflow: hidden;
  button {
    border: 0;
    background: #fff;
    color: #176b50;
    padding: 9px 18px;
    font-weight: bold;
    white-space: nowrap;
  }
  button.active { background: #16845f; color: #fff; }
}
.order-list-tools {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.order-list-page {
  padding-top: 48px;
}
.order-date-filter {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 576px;
  margin-left: auto;
  .mx-datepicker {
    flex: 1 1 0;
    width: auto;
    min-width: 0;
  }
  &__separator {
    width: 16px;
    height: 2px;
    flex: 0 0 16px;
    background: #16845f;
  }
  &__button { margin: 0; }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .order-list-tools {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .order-source-tabs {
    display: flex;
    width: 100%;
    button { flex: 1 1 50%; }
  }
  .order-date-filter {
    width: 100%;
    max-width: none;
    margin-left: 0;
  }
}
@media (max-width: 575.98px) {
  .order-list-tools {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .order-source-tabs {
    display: flex;
    flex: none;
    width: 100%;
    button { flex: 1 1 50%; padding: 9px 8px; }
  }
  .order-date-filter {
    gap: 6px;
    max-width: none;
    .mx-input {
      height: 38px;
      padding-right: 28px;
      padding-left: 8px;
      font-size: 13px;
    }
    &__separator {
      width: 10px;
      flex-basis: 10px;
    }
    &__button {
      width: 38px;
      min-width: 38px;
      padding: 6px;
    }
  }
}
.tracking-status { color: #176b50; font-weight: bold; }
.btn-position {
  position: relative;
  z-index: 2;
}
.cancel-order-button,
.cancel-order-icon-button {
  min-height: 38px;
}
.cancel-order-icon-button {
  min-width: 38px;
}
.cancel-order-button.is-loading,
.cancel-order-icon-button.is-loading {
  cursor: wait;
  opacity: .75;
}
</style>

<style scoped>
.order-history-notice { position: relative; margin-left: 15px; font-size: 16px; line-height: 1.5; }
.order-history-notice::before { content: ""; position: absolute; width: 8px; height: 8px; background: #56870F; border-radius: 50%; left: -15px; top: 8px; }
</style>
